import styles from "../styles/home.module.css";
import music from "../assets/E=Y.mp3";
import pdf from "../assets/E=Y.pdf";


export default function Home({ goKey }) {
return (
<div className={styles.studio}>
<h1>Your Music Studio</h1>
<p></p>


<audio autoPlay loop>
<source src={music} type="audio/mpeg" />
</audio>


<div className={styles.pdfContainer}>
<iframe src={pdf} title="Music PDF" />
</div>


<button onClick={goKey}>Go to the Old Paper</button>
</div>
);
}